export class BoxModel {
    public id!: string;
    public barCode!: string;
    public description!: string;
}